import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./style.css";
import image from "assests/about/about-us-2.jpg";
import { motion, useTransform, useMotionValue } from "framer-motion";
import lineYellow from "assests/about/hero-line.png";

const Hero = ({ data }) => {
  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    const tl = gsap
      .timeline({
        scrollTrigger: {
          trigger: ".orangeWrapper",
          scrub: 1,
          pin: true,
          start: "top top",
          end: "+=400%",
        },
      })
      .fromTo(
        ".orange",
        { scale: 1, borderRadius: "50%" },
        { scale: 3, ease: "none" }
      )
      .from(
        ".line-2",
        {
          scaleX: 0,
          ease: "none",
          transformOrigin: "left top",
        },
        0
      );

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  const scrollY = useMotionValue(0);

  // First section translates up and fades out
  const firstSectionY = useTransform(scrollY, [0, 800], [0, -200]); // Adjusted for correct positioning
  const firstSectionOpacity = useTransform(scrollY, [0, 800], [1, 0]);

  // Second section translates up and fades in
  const secondSectionY = useTransform(scrollY, [900, 1500], [100, 0]); // Starts from below
  const secondSectionOpacity = useTransform(scrollY, [900, 1500], [0, 1]); // Fades in

  useEffect(() => {
    const handleScroll = () => {
      scrollY.set(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollY]);

  return (
    <div className="panel orangeWrapper bg-[#252525] pt-[10vh] relative hidden">
      <div className="flex items-center justify-center absolute top-0 left-0 h-[100vh]  z-[1000] w-[100vw]">
        <img src={lineYellow} className="" alt="" />
      </div>
      <img src={image} className="panel orange z-[100]" alt="" />

      {data?.map(({ title, text, sub_title }, index) => (
        <div
          className="w-1/2 xxl:px-32 xl:px-16 px-10 mb-14  text-scenter left-1/2 -translate-x-1/2 absolute z-[1000] text-white flex flex-col"
          key={index}
        >
          <motion.div
            style={{
              y: index === 0 ? firstSectionY : secondSectionY,
              opacity: index === 0 ? firstSectionOpacity : secondSectionOpacity,
            }}
          >
            <h1 className="text-xl font-bold">{sub_title}</h1>
            <p className="titles-font text-3xl text-secondary capitalize">
              {title}
            </p>
            <p
              className="text-centser mt-3  "
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </motion.div>
        </div>
      ))}
    </div>
  );
};

export default Hero;
